var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNginx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 55.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #009639;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.3,39.1c.2.4.5.7.9.9l17.6,10.2c.7.4,1.6.4,2.3,0l17.6-10.2c.7-.4,1.2-1.2,1.2-2v-20.4c0-.8-.4-1.6-1.2-2L26.2,5.3c-.7-.4-1.6-.4-2.3,0S6.2,15.5,6.2,15.5c-.7.4-1.2,1.2-1.2,2v20.4c0,.4.1.8.3,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.3,35.5c0,1.2-1,2.3-2.3,2.3s-2.3-1-2.3-2.3v-15.6c0-1.2,1.1-2.2,2.6-2.2,1.2,0,2.3.5,3.1,1.4l.7.8,9.5,11.4v-11.3c0-1.2,1-2.3,2.3-2.3s2.3,1,2.3,2.3v15.6c0,1.2-1.1,2.2-2.6,2.2-1.2,0-2.3-.5-3.1-1.4l-10.2-12.2v11.3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNginx);
export default __webpack_public_path__ + "static/media/nginx.848ee6075f373f0e51d0d9e425abe49f.svg";
export { ForwardRef as ReactComponent };